// Mock data for Herzogparksuiten website

export const navigationItems = [
  { id: 1, label: "Das Haus", href: "#suites" },
  { id: 2, label: "Die Lage", href: "#herzogpark" },
];

export const heroSlides = [
  {
    id: 1,
    title: "MK118",
    backgroundImage: "/images/aussenanllage/image.jpg",
  },
  {
    id: 2,
    title: "EXKLUSIVES\nWOHNEN",
    backgroundImage: "/images/wohnzimmer-kueche/A7C07097.jpg",
  },
  {
    id: 3,
    title: "MÜNCHEN\nBOGENHAUSEN",
    backgroundImage: "/images/aussenanllage/A7C07075.jpg",
  },
  {
    id: 4,
    title: "DESIGN &\nKOMFORT",
    backgroundImage: "/images/dachgeschoss/A7C06874.jpg",
  },
];

export const introData = {
  heading: "Exklusives Wohnen im Herzogpark",
  paragraphs: [
    "Eingebettet in die grüne Idylle des Münchner Herzogparks erwartet Sie ein vollmöbliertes Haus, das höchste Ansprüche an Design, Komfort und Sicherheit vereint.",
    "Der großzügig angelegte Garten mit 30 Photinia-fraseri-Red-Robin-Bäumen und drei mediterranen Olivenbäumen schafft eine private Oase – ergänzt durch einen Whirlpool mit Außendusche, eine automatische Bewässerung sowie eine stimmungsvolle Gartenbeleuchtung.",
    "Im Inneren setzt die exklusive Occhio-Beleuchtung elegante Akzente, während vier Badezimmer – eines mit Badewanne und drei mit Dusche – jeden Komfort bieten. Eine Sauna im Untergeschoss, eine Enthärtungsanlage mit BWT-Wasserfilter und Miele-Geräte runden das hochwertige Gesamtkonzept ab.",
  ],
};

export const galleryCategories = [
  { id: "wohnzimmer-kueche", label: "Wohnzimmer & Küche" },
  { id: "erste-etage", label: "Erste Etage" },
  { id: "dachgeschoss", label: "Dachgeschoss" },
  { id: "gaeste-wc-flur", label: "Gäste-WC & Flur" },
  { id: "aussenanlage", label: "Außenanlage & Garage" },
  { id: "keller", label: "Keller" },
  { id: "grundriss", label: "Grundriss" },
];

export const galleryImages = [
  // Wohnzimmer & Küche
  {
    id: 1,
    url: "/images/wohnzimmer-kueche/A7C06997.jpg",
    alt: "Wohnzimmer",
    category: "wohnzimmer-kueche",
  },
  {
    id: 2,
    url: "/images/wohnzimmer-kueche/A7C06999.jpg",
    alt: "Wohnbereich",
    category: "wohnzimmer-kueche",
  },
  {
    id: 3,
    url: "/images/wohnzimmer-kueche/A7C07008.jpg",
    alt: "Küche",
    category: "wohnzimmer-kueche",
  },
  {
    id: 4,
    url: "/images/wohnzimmer-kueche/A7C07011.jpg",
    alt: "Küchenzeile",
    category: "wohnzimmer-kueche",
  },
  {
    id: 5,
    url: "/images/wohnzimmer-kueche/A7C07018.jpg",
    alt: "Essbereich",
    category: "wohnzimmer-kueche",
  },
  {
    id: 6,
    url: "/images/wohnzimmer-kueche/A7C07043.jpg",
    alt: "Wohnzimmer Detail",
    category: "wohnzimmer-kueche",
  },
  {
    id: 7,
    url: "/images/wohnzimmer-kueche/A7C07097.jpg",
    alt: "Wohnraum",
    category: "wohnzimmer-kueche",
  },
  {
    id: 8,
    url: "/images/wohnzimmer-kueche/A7C07101.jpg",
    alt: "Küche Detail",
    category: "wohnzimmer-kueche",
  },
  {
    id: 9,
    url: "/images/wohnzimmer-kueche/A7C07104.jpg",
    alt: "Wohn-Essbereich",
    category: "wohnzimmer-kueche",
  },
  {
    id: 10,
    url: "/images/wohnzimmer-kueche/A7C07106.jpg",
    alt: "Wohnzimmer Ansicht",
    category: "wohnzimmer-kueche",
  },
  {
    id: 11,
    url: "/images/wohnzimmer-kueche/A7C07110.jpg",
    alt: "Offene Küche",
    category: "wohnzimmer-kueche",
  },
  {
    id: 12,
    url: "/images/wohnzimmer-kueche/image4.jpg",
    alt: "Wohnbereich Übersicht",
    category: "wohnzimmer-kueche",
  },
  // Erste Etage
  {
    id: 13,
    url: "/images/erste-etage/A7C06903.jpg",
    alt: "Erste Etage Zimmer",
    category: "erste-etage",
  },
  {
    id: 14,
    url: "/images/erste-etage/A7C06905.jpg",
    alt: "Schlafzimmer",
    category: "erste-etage",
  },
  {
    id: 15,
    url: "/images/erste-etage/A7C06913.jpg",
    alt: "Erste Etage Bad",
    category: "erste-etage",
  },
  {
    id: 16,
    url: "/images/erste-etage/A7C06915.jpg",
    alt: "Badezimmer Detail",
    category: "erste-etage",
  },
  {
    id: 17,
    url: "/images/erste-etage/A7C06919.jpg",
    alt: "Schlafbereich",
    category: "erste-etage",
  },
  {
    id: 18,
    url: "/images/erste-etage/A7C06932.jpg",
    alt: "Erste Etage Ansicht",
    category: "erste-etage",
  },
  {
    id: 19,
    url: "/images/erste-etage/A7C06934.jpg",
    alt: "Zimmer Detail",
    category: "erste-etage",
  },
  {
    id: 20,
    url: "/images/erste-etage/A7C06935.jpg",
    alt: "Erste Etage Flur",
    category: "erste-etage",
  },
  {
    id: 21,
    url: "/images/erste-etage/A7C06947.jpg",
    alt: "Raum Übersicht",
    category: "erste-etage",
  },
  {
    id: 22,
    url: "/images/erste-etage/image.jpg",
    alt: "Erste Etage",
    category: "erste-etage",
  },
  {
    id: 23,
    url: "/images/erste-etage/image-Kopie.jpg",
    alt: "Erste Etage Ansicht",
    category: "erste-etage",
  },
  {
    id: 24,
    url: "/images/erste-etage/image1.jpg",
    alt: "Raum",
    category: "erste-etage",
  },
  {
    id: 25,
    url: "/images/erste-etage/image2.jpg",
    alt: "Zimmer",
    category: "erste-etage",
  },
  {
    id: 26,
    url: "/images/erste-etage/image3.jpg",
    alt: "Schlafzimmer Ansicht",
    category: "erste-etage",
  },
  {
    id: 27,
    url: "/images/erste-etage/image8.jpg",
    alt: "Bad Erste Etage",
    category: "erste-etage",
  },
  // Dachgeschoss
  {
    id: 28,
    url: "/images/dachgeschoss/A7C06874.jpg",
    alt: "Dachgeschoss Zimmer",
    category: "dachgeschoss",
  },
  {
    id: 29,
    url: "/images/dachgeschoss/A7C06882.jpg",
    alt: "Dachgeschoss Ansicht",
    category: "dachgeschoss",
  },
  {
    id: 30,
    url: "/images/dachgeschoss/A7C06885.jpg",
    alt: "Dachgeschoss Schlafzimmer",
    category: "dachgeschoss",
  },
  {
    id: 31,
    url: "/images/dachgeschoss/A7C06886.jpg",
    alt: "Dachgeschoss Detail",
    category: "dachgeschoss",
  },
  {
    id: 32,
    url: "/images/dachgeschoss/A7C06887.jpg",
    alt: "Dachgeschoss Bad",
    category: "dachgeschoss",
  },
  {
    id: 33,
    url: "/images/dachgeschoss/A7C06888.jpg",
    alt: "Dachgeschoss Badezimmer",
    category: "dachgeschoss",
  },
  {
    id: 34,
    url: "/images/dachgeschoss/A7C06892.jpg",
    alt: "Dachgeschoss Raum",
    category: "dachgeschoss",
  },
  {
    id: 35,
    url: "/images/dachgeschoss/A7C06894.jpg",
    alt: "Dachzimmer",
    category: "dachgeschoss",
  },
  {
    id: 36,
    url: "/images/dachgeschoss/A7C06900.jpg",
    alt: "Dachgeschoss Übersicht",
    category: "dachgeschoss",
  },
  {
    id: 37,
    url: "/images/dachgeschoss/A7C06902.jpg",
    alt: "Dachgeschoss Fenster",
    category: "dachgeschoss",
  },
  // Gäste-WC & Flur
  {
    id: 38,
    url: "/images/gaeste-wc-flur/A7C06985.jpg",
    alt: "Gäste-WC",
    category: "gaeste-wc-flur",
  },
  {
    id: 39,
    url: "/images/gaeste-wc-flur/A7C06988.jpg",
    alt: "Flur",
    category: "gaeste-wc-flur",
  },
  {
    id: 40,
    url: "/images/gaeste-wc-flur/A7C06990.jpg",
    alt: "Gäste-WC Detail",
    category: "gaeste-wc-flur",
  },
  {
    id: 41,
    url: "/images/gaeste-wc-flur/A7C06992.jpg",
    alt: "Flur Ansicht",
    category: "gaeste-wc-flur",
  },
  {
    id: 42,
    url: "/images/gaeste-wc-flur/image.jpg",
    alt: "Eingangsbereich",
    category: "gaeste-wc-flur",
  },
  // Außenanlage
  {
    id: 43,
    url: "/images/aussenanllage/A7C07075.jpg",
    alt: "Garten",
    category: "aussenanlage",
  },
  {
    id: 44,
    url: "/images/aussenanllage/A7C07079.jpg",
    alt: "Außenansicht",
    category: "aussenanlage",
  },
  {
    id: 45,
    url: "/images/aussenanllage/A7C07080.jpg",
    alt: "Terrasse",
    category: "aussenanlage",
  },
  {
    id: 46,
    url: "/images/aussenanllage/A7C07081.jpg",
    alt: "Gartenbereich",
    category: "aussenanlage",
  },
  {
    id: 47,
    url: "/images/aussenanllage/A7C07082.jpg",
    alt: "Außenanlage",
    category: "aussenanlage",
  },
  {
    id: 48,
    url: "/images/aussenanllage/A7C07086.jpg",
    alt: "Whirlpool",
    category: "aussenanlage",
  },
  {
    id: 49,
    url: "/images/aussenanllage/A7C07088.jpg",
    alt: "Garten Detail",
    category: "aussenanlage",
  },
  {
    id: 50,
    url: "/images/aussenanllage/A7C07122.jpg",
    alt: "Außenbereich",
    category: "aussenanlage",
  },
  {
    id: 51,
    url: "/images/aussenanllage/image.jpg",
    alt: "Haus Außenansicht",
    category: "aussenanlage",
  },
  {
    id: 53,
    url: "/images/aussenanllage/image3.jpg",
    alt: "Gartenanlage",
    category: "aussenanlage",
  },
  {
    id: 55,
    url: "/images/aussenanllage/image5.jpg",
    alt: "Einfahrt",
    category: "aussenanlage",
  },
  {
    id: 56,
    url: "/images/aussenanllage/image6.jpg",
    alt: "Carport",
    category: "aussenanlage",
  },
  {
    id: 57,
    url: "/images/aussenanllage/image7.jpg",
    alt: "Garten Übersicht",
    category: "aussenanlage",
  },
  {
    id: 58,
    url: "/images/aussenanllage/image9.jpg",
    alt: "Beleuchtung Garten",
    category: "aussenanlage",
  },
  {
    id: 59,
    url: "/images/aussenanllage/image_treppe.jpg",
    alt: "Außentreppe",
    category: "aussenanlage",
  },
  // Keller & Sauna
  {
    id: 70,
    url: "/images/keller-sauna/A7C06952.jpg",
    alt: "Keller",
    category: "keller",
  },
  {
    id: 71,
    url: "/images/keller-sauna/A7C06956.jpg",
    alt: "Keller Bereich",
    category: "keller",
  },
  {
    id: 72,
    url: "/images/keller-sauna/A7C06966.jpg",
    alt: "Sauna",
    category: "keller",
  },
  {
    id: 73,
    url: "/images/keller-sauna/A7C06969.jpg",
    alt: "Sauna Bereich",
    category: "keller",
  },
  {
    id: 74,
    url: "/images/keller-sauna/A7C06971.jpg",
    alt: "Keller Detail",
    category: "keller",
  },
  {
    id: 75,
    url: "/images/keller-sauna/A7C06974.jpg",
    alt: "Keller Übersicht",
    category: "keller",
  },
  // Grundriss
  {
    id: 60,
    url: "/images/grundriss/erdgeschoss.jpg",
    alt: "Grundriss Erdgeschoss",
    category: "grundriss",
  },
  {
    id: 61,
    url: "/images/grundriss/1-etage.jpg",
    alt: "Grundriss 1. Etage",
    category: "grundriss",
  },
  {
    id: 62,
    url: "/images/grundriss/2-etage.jpg",
    alt: "Grundriss 2. Etage",
    category: "grundriss",
  },
  {
    id: 63,
    url: "/images/grundriss/keller.jpg",
    alt: "Grundriss Keller",
    category: "grundriss",
  },
];

export const testimonials = [
  {
    id: 1,
    quote:
      '"Wer die perfekte Synthese aus Architektur, feinsinnigem Interior und angenehmer Ruhe sucht, ist hier bestens aufgehoben."',
    author: "Felix E.",
  },
  {
    id: 2,
    quote:
      '"Selten habe ich mich in einer fremden Stadt so wohlgefühlt wie hier im Herzogpark."',
    author: "Travis S.",
  },
];

export const amenitiesData = {
  title: "Ausstattung & Highlights",
  items: [
    "Vollständig möbliert mit hochwertigen Designmöbeln",
    "Whirlpool im Garten mit Außendusche",
    "Sauna im Keller",
    "Exklusive Occhio-Beleuchtung",
    "Garage und Carport",
    "Garten mit 30 Photinia-Bäumen und 3 Olivenbäumen",
    "4 Badezimmer – 1× Badewanne, 3× Dusche",
    "Alarmanlage innen und außen",
    "Kameraüberwachung innen und außen",
    "Automatische Gartenbewässerung und -beleuchtung",
    "Alle Fenster mit Rollos",
    "Enthärtungsanlage und BWT-Wasserfilter",
    "Miele Waschmaschine und Trockner",
    "Calacatta-Fliesen in der Garage",
  ],
};

export const locationData = {
  address: "Mauerkircherstraße 118, 81925 München",
  mapUrl:
    "https://www.google.com/maps/place/Mauerkircherstra%C3%9Fe+118,+81679+M%C3%BCnchen/@48.1541,11.6058,17z",
};

export const footerData = {
  links: [{ id: 1, label: "Impressum / Datenschutz", href: "#" }],
};
